// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20jj0","content":"styles_content__37adS"};